var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 98,
    viewBox: "0 0 109 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8434 10.6356C62.5894 8.17357 57.5291 7.52214 52.7903 8.79188L17.8807 18.1459C7.98269 20.7981 2.1399 30.9232 4.78164 40.7823L12.2618 68.6988C14.9036 78.5579 25.0615 84.3957 34.9241 81.753L69.8338 72.399C79.6964 69.7563 85.5781 59.6207 82.9364 49.7616L75.4562 21.8451C74.1874 17.11 71.099 13.0896 66.8434 10.6356Z",
    fill: "url(#paint0_linear_114_1920)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_114_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1741 19.817C54.4901 18.1713 51.3158 17.7039 48.3586 18.4963L26.5727 24.3338C20.3958 25.9889 16.8191 32.5672 18.5535 39.0404L23.4648 57.3694C25.1993 63.8426 31.608 67.7453 37.7629 66.0961L59.5487 60.2586C65.7036 58.6094 69.3046 52.0246 67.5701 45.5514L62.6589 27.2224C61.8258 24.1134 59.8591 21.4574 57.1741 19.817Z",
    fill: "#0062FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_114_1920)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_114_1920",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 22,
    width: 84,
    height: 76,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 23,
    y: 22,
    width: 84,
    height: 76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6192 29.0474C95.7442 25.1642 90.4767 23 85.0009 23H44.6617C33.2242 23 24 32.2283 24 43.6208V75.8792C24 87.2717 33.2651 96.5 44.6617 96.5H85.0009C96.3975 96.5 105.667 87.2717 105.667 75.8792V43.6208C105.667 38.1492 103.498 32.9225 99.6192 29.0474Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.6192 29.0474C95.7442 25.1642 90.4767 23 85.0009 23H44.6617C33.2242 23 24 32.2283 24 43.6208V75.8792C24 87.2717 33.2651 96.5 44.6617 96.5H85.0009C96.3975 96.5 105.667 87.2717 105.667 75.8792V43.6208C105.667 38.1492 103.498 32.9225 99.6192 29.0474Z",
    fill: "url(#paint1_linear_114_1920)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9676 29.6976C99.3268 30.0575 99.9096 30.0581 100.269 29.699C100.629 29.3399 100.63 28.7571 100.271 28.3972L98.9676 29.6976ZM100.27 28.3962C99.9101 28.0369 99.3273 28.0372 98.968 28.3968C98.6087 28.7565 98.609 29.3394 98.9687 29.6987L100.27 28.3962ZM100.271 28.3972C96.2216 24.3394 90.719 22.0795 85.0009 22.0795V23.9205C90.2343 23.9205 95.2668 25.989 98.9676 29.6976L100.271 28.3972ZM85.0009 22.0795H44.6617V23.9205H85.0009V22.0795ZM44.6617 22.0795C32.7169 22.0795 23.0795 31.7189 23.0795 43.6208H24.9205C24.9205 32.7378 33.7316 23.9205 44.6617 23.9205V22.0795ZM23.0795 43.6208V75.8792H24.9205V43.6208H23.0795ZM23.0795 75.8792C23.0795 87.7823 32.7589 97.4205 44.6617 97.4205V95.5795C33.7712 95.5795 24.9205 86.761 24.9205 75.8792H23.0795ZM44.6617 97.4205H85.0009V95.5795H44.6617V97.4205ZM85.0009 97.4205C96.9034 97.4205 106.587 87.7826 106.587 75.8792H104.746C104.746 86.7608 95.8916 95.5795 85.0009 95.5795V97.4205ZM106.587 75.8792V43.6208H104.746V75.8792H106.587ZM106.587 43.6208C106.587 37.9044 104.321 32.4436 100.27 28.3962L98.9687 29.6987C102.675 33.4014 104.746 38.3939 104.746 43.6208H106.587Z",
    fill: "url(#paint2_linear_114_1920)",
    mask: "url(#path-3-outside-1_114_1920)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_114_1920)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_114_1920",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8244 49.3781L91.4977 49.7047L73.0778 64.4456C70.7952 66.2422 67.9736 67.2222 65.0785 67.2222C62.1753 67.2222 59.4027 66.2422 57.116 64.4456L38.5369 49.9497L38.002 49.4189C37.0669 48.1939 37.1894 46.4381 38.2919 45.3356C39.3495 44.2331 41.1053 44.1106 42.3752 45.0497L60.7502 59.7497C63.1553 61.7138 66.5485 61.7138 68.9169 59.7497L87.3286 45.0497C87.9452 44.4781 88.7619 44.1881 89.6194 44.2331C90.432 44.3147 91.2119 44.6863 91.7795 45.2947C92.8003 46.4789 92.8003 48.1939 91.8244 49.3781Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.8244 49.3781L91.4977 49.7047L73.0778 64.4456C70.7952 66.2422 67.9736 67.2222 65.0785 67.2222C62.1753 67.2222 59.4027 66.2422 57.116 64.4456L38.5369 49.9497L38.002 49.4189C37.0669 48.1939 37.1894 46.4381 38.2919 45.3356C39.3495 44.2331 41.1053 44.1106 42.3752 45.0497L60.7502 59.7497C63.1553 61.7138 66.5485 61.7138 68.9169 59.7497L87.3286 45.0497C87.9452 44.4781 88.7619 44.1881 89.6194 44.2331C90.432 44.3147 91.2119 44.6863 91.7795 45.2947C92.8003 46.4789 92.8003 48.1939 91.8244 49.3781Z",
    fill: "url(#paint3_linear_114_1920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4977 49.7047L91.6174 49.8543L91.6257 49.8477L91.6332 49.8402L91.4977 49.7047ZM73.0778 64.4456L73.1963 64.5961L73.1975 64.5952L73.0778 64.4456ZM57.116 64.4456L57.2344 64.2949L57.2339 64.2945L57.116 64.4456ZM38.5369 49.9497L38.4019 50.0857L38.41 50.0938L38.419 50.1008L38.5369 49.9497ZM38.002 49.4189L37.8496 49.5352L37.8576 49.5456L37.867 49.5549L38.002 49.4189ZM38.2919 45.3356L38.4274 45.4711L38.4302 45.4682L38.2919 45.3356ZM42.3752 45.0497L42.495 44.9L42.4892 44.8956L42.3752 45.0497ZM60.7502 59.7497L60.8714 59.6013L60.8699 59.6001L60.7502 59.7497ZM68.9169 59.7497L68.7973 59.5999L68.7945 59.6022L68.9169 59.7497ZM87.3286 45.0497L87.4482 45.1995L87.4537 45.1951L87.4589 45.1903L87.3286 45.0497ZM89.6194 44.2331L89.6386 44.0421L89.6294 44.0417L89.6194 44.2331ZM91.7795 45.2947L91.9247 45.1695L91.9196 45.164L91.7795 45.2947ZM91.6889 49.2425L91.3622 49.5692L91.6332 49.8402L91.9599 49.5136L91.6889 49.2425ZM91.378 49.5551L72.958 64.2959L73.1975 64.5952L91.6174 49.8543L91.378 49.5551ZM72.9593 64.295C70.7103 66.0652 67.9304 67.0306 65.0785 67.0306V67.4139C68.0168 67.4139 70.8801 66.4193 73.1963 64.5961L72.9593 64.295ZM65.0785 67.0306C62.2192 67.0306 59.4881 66.0656 57.2344 64.2949L56.9976 64.5962C59.3173 66.4188 62.1314 67.4139 65.0785 67.4139V67.0306ZM57.2339 64.2945L38.6548 49.7986L38.419 50.1008L56.9981 64.5966L57.2339 64.2945ZM38.6719 49.8137L38.1369 49.2829L37.867 49.5549L38.4019 50.0857L38.6719 49.8137ZM38.1543 49.3026C37.2782 48.1549 37.3918 46.5066 38.4274 45.4711L38.1564 45.2C36.9869 46.3695 36.8555 48.2328 37.8496 49.5352L38.1543 49.3026ZM38.4302 45.4682C39.4175 44.4389 41.0647 44.3189 42.2612 45.2038L42.4892 44.8956C41.1458 43.9022 39.2814 44.0272 38.1536 45.2029L38.4302 45.4682ZM42.2555 45.1994L60.6305 59.8994L60.8699 59.6001L42.4949 44.9001L42.2555 45.1994ZM60.629 59.8982C63.1041 61.9194 66.5994 61.9206 69.0392 59.8972L68.7945 59.6022C66.4977 61.507 63.2065 61.5082 60.8714 59.6013L60.629 59.8982ZM69.0364 59.8995L87.4482 45.1995L87.209 44.9L68.7973 59.6L69.0364 59.8995ZM87.4589 45.1903C88.0364 44.6548 88.802 44.3821 89.6093 44.4244L89.6294 44.0417C88.7217 43.9941 87.854 44.3013 87.1983 44.9092L87.4589 45.1903ZM89.6002 44.4237C90.3683 44.5009 91.1047 44.8523 91.6393 45.4254L91.9196 45.164C91.3191 44.5203 90.4956 44.1285 89.6385 44.0424L89.6002 44.4237ZM91.6343 45.4198C92.5935 46.5325 92.5938 48.1432 91.6765 49.2562L91.9723 49.4999C93.0068 48.2446 93.0071 46.4253 91.9246 45.1696L91.6343 45.4198Z",
    fill: "url(#paint4_linear_114_1920)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_114_1920)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_114_1920",
    x: 0.868126,
    y: 0.872154,
    width: 84.3856,
    height: 82.8499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.62398,
    result: "effect1_foregroundBlur_114_1920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_114_1920",
    x: 0.986635,
    y: -0.0132427,
    width: 127.693,
    height: 119.526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_114_1920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_114_1920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_114_1920",
    x: 23.0017,
    y: 29.8552,
    width: 85.8388,
    height: 53.6567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.18665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_114_1920"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.7911,
    dy: 4.7911
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_114_1920",
    result: "effect2_dropShadow_114_1920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_114_1920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_1920",
    x1: 35.2563,
    y1: 13.3845,
    x2: 52.4875,
    y2: 77.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_114_1920",
    x1: 64.7703,
    y1: 22.8862,
    x2: 64.7703,
    y2: 97.1957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_114_1920",
    x1: 37,
    y1: 31.5628,
    x2: 98.5549,
    y2: 98.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_114_1920",
    x1: 88.6389,
    y1: 48.3807,
    x2: 27.4873,
    y2: 53.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_114_1920",
    x1: 43.3186,
    y1: 51.9418,
    x2: 90.1637,
    y2: 52.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.ecfac0242fd9586f82344855273feba1.svg";
export { ForwardRef as ReactComponent };